module.exports = __webpack_public_path__ + "img/frameHover.c2e2379c.png";